import { api as axios } from '@/plugins/axios.js';

export const getSheds = async (token, limit = null, offset = null, params = null, state = null) => {
  const config = {
    method: 'get',
    url: `/v2/sheds/${state}`,
    headers: {
      'Authorization': `Bearer ${token}`,
    },
    params: {
      // Pagination
      limit,
      offset,

      // Filters by attributes
      producer: params.producer,
      name: params.name,
      identification: params.identification,
      property: params.property,
      lineage: params.lineage,
      sex: params.sex,
      age: params.age,
      production_type__external_id: params.production_type__external_id,
      breeding: params.breeding,

      // Filters by performance
      weight: params.weight,
      variation_coef: params.variation_coef,
      performance: params.performance,

      // Filters by nutrition
      ration__id: params.ration__id,
      ration__phase: params.ration__phase,
      status: params.status,
      available: params.available,

      // Filters by Status
      enthalpy: params.enthalpy,
      stage: params.stage,

      // Sorting
      ordering: params.ordering,

      // PCP Planning
      target_value: params.target_weight,
      target_date: params.target_date,
    },
  };
  const { data } = await axios(config);
  return data;
};

export const getShedDetails = async (token, id, params = undefined) => {
  const config = {
    method: 'get',
    url: `/v2/sheds/${id}`,
    params,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
  };
  const { data } = await axios(config);
  return data;
};

export const getRationPrediction = async (token, id, params = undefined) => {
  const config = {
    method: 'get',
    url: `/v2/sheds/${id}/nutrition`,
    params,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
  };
  const { data } = await axios(config);
  return data;
};

export const getBatchDetails = async (token, batchId, state = undefined) => {
  const config = {
    method: 'get',
    url: `/v2/batches/${batchId}` + (state ? `/${state}` : ''),
    headers: {
      'Authorization': 'Bearer ' + token,
    },
  };
  const { data } = await axios(config);
  return data;
};

export const getBatchConsumptionHistory = async (token, batchId, params) => {
  const config = {
    method: 'get',
    url: `/v2/batches/${batchId}/consumption-history`,
    params,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
  };
  const { data } = await axios(config);
  return data;
};

export const editShed = async (token, id, params = undefined) => {
  const config = {
    method: 'patch',
    url: `/v2/sheds/${id}/`,
    data: params,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
  };
  const { data } = await axios(config);
  return data;
};

export const editBatch = async (token, id, params = undefined) => {
  const config = {
    method: 'patch',
    url: `/v2/batches/${id}/`,
    data: params,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
  };
  const { data } = await axios(config);
  return data;
};

export const postBatch = async (token, payload) => {
  const config = {
    method: 'post',
    url: `/v2/batches/`,
    data: payload,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
  };
  const { data } = await axios(config);
  return data;
};

export const getLineages = async (token, params = undefined) => {
  const config = {
    method: 'get',
    url: `/v2/lineages/`,
    params,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
  };
  const { data } = await axios(config);
  return data;
};

export const getSexes = async (token, params = undefined) => {
  const config = {
    method: 'get',
    url: `/v2/sexes/`,
    params,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
  };
  const { data } = await axios(config);
  return data;
};

export const getProductionTypes = async (token, params = undefined) => {
  const config = {
    method: 'get',
    url: `/v2/production_types/`,
    params,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
  };
  const { data } = await axios(config);
  return data;
};

export const getBreedingTypes = async (token, params = undefined) => {
  const config = {
    method: 'get',
    url: `/v2/breeding_types/`,
    params,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
  };
  const { data } = await axios(config);
  return data;
};

export const getMortality = async (token, params = undefined) => {
  const config = {
    method: 'get',
    url: `/v1/mortality-control/`,
    params,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
  };
  const { data } = await axios(config);
  return data;
};

export const updateMortality = async (token, id, payload) => {
  const config = {
    method: 'patch',
    url: `/v1/mortality-control/${id}/`,
    data: payload,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  };

  const { data } = await axios(config);
  return data;
};

export const createMortality = async (token, payload) => {
  const config = {
    method: 'post',
    url: `/v1/mortality-control/`,
    data: payload,
    headers: {
      'Authorization': 'Bearer ' + token,
    },
  };
  const { data } = await axios(config);
  return data;
};
